import React, { FC, PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { GridSkeletons } from 'app/design-system/components/Skeleton/GridSkeleton';

import styles from './Skeleton.module.scss';

// ---

const MATCH_SKELETON_HEIGHT = 135;

type SkeletonsContainerProps = PropsWithChildren<{
  height?: number | null;
}>;

const BettingSkeletonsContainer: FC<SkeletonsContainerProps> = ({
  height,
  children,
}) => (
  <ul className={styles.bettingSkeletonList}
      style={height ? { height: `${height}px` } : undefined}>
    {children}
  </ul>
);

const BettingSkeleton: FC = () => {
  const matchesContainerHeight = useSelector((state: ReduxState) => (
    state.prematch.get('matchesContainerHeight')
  ));
  const screenHeight = useSelector((state: ReduxState) => state.screen.innerHeight);

  if (!matchesContainerHeight) {
    return (
      <BettingSkeletonsContainer>
        <GridSkeletons />
        <GridSkeletons />
        <GridSkeletons />
        <GridSkeletons />
        <GridSkeletons />
      </BettingSkeletonsContainer>
    );
  }


  const skeletons = [];
  let skeletonsAmount: number;
  let skeletonsContainerHeight: number | null = null;

  if (matchesContainerHeight > screenHeight) {
    skeletonsAmount = Math.floor(screenHeight / MATCH_SKELETON_HEIGHT);
  }
  else {
    skeletonsAmount = Math.floor(matchesContainerHeight / MATCH_SKELETON_HEIGHT);
    skeletonsContainerHeight = matchesContainerHeight;
  }

  for (let i = 0; i < skeletonsAmount; i++) {
    skeletons.push(<GridSkeletons key={i} />);
  }

  return (
    <BettingSkeletonsContainer height={skeletonsContainerHeight}>
      {skeletons}
    </BettingSkeletonsContainer>
  );
};

export default BettingSkeleton;
